import { createGlobalStyle } from "styled-components";

// The resting-state look for .footer-button-primary (navy fill, flat,
// radius-sm, no shadow) is set via inline style (drawerStyles.ts's
// footerButtonPrimary), since it's applied through a generic ControlButton
// prop, not a styled-component. Inline styles can't express :hover or
// :focus-visible, so those two states live here instead -- matching the
// orange-hover pattern used by every other primary action button in the app
// (Add resource, Add Banner, BackgroundStyleToggle).
export const ControlButtonGlobalStyle = createGlobalStyle`
.footer-button-primary:hover {
    background-color: var(--color-accent-light) !important;
    border-color: var(--color-accent-light) !important;
}

.footer-button-primary:focus-visible {
    outline: none;
    box-shadow: var(--shadow-button-focus, 0 0 0px 2px #fff, 0 0 3px 4px rgba(234, 133, 34, 0.5));
}
`;